<template>
  <el-dialog
    title=""
    width="480px"
    :visible="true"
    :close-on-click-modal="false"
    :show-close="false"
    :before-close="() => $emit('remove')"
  >
    <el-row
      v-if="checkBoxList && checkBoxList.length"
      type="flex"
      style="
        flex-wrap: nowrap;
        /* margin: 0 auto; */
        display: flex;
        justify-content: center;
        align-items: center;
        width: 100%;
        padding: 16px 40px;
        border: 1px solid #fff;
      "
    >
      <div
        v-if="checkBoxList.length"
        style=" display: flex; flex-direction: column"
      >
        <el-checkbox
          v-for="(box, index) in checkBoxList"
          :key="index"
          :lable="box.isProjectBiV3 !== 1 ? +box.modelType : box.modelType"
          :true-label="box.isProjectBiV3 !== 1 ? +box.modelType : box.modelType"
          v-model="checkList[index]"
        >
          {{ box.label }}
        </el-checkbox>
      </div>
    </el-row>
    <span slot="footer" class="dialog-footer">
      <el-row type="flex" justify="center" align="middle">
        <el-button @click="$emit('remove')" style="margin-right: 100px;">
          取 消
        </el-button>
        <el-button
          :disabled="!checkList.length"
          type="primary"
          @click="confirm"
        >
          确 定
        </el-button>
      </el-row>
    </span>
  </el-dialog>
</template>

<script>
import { BIv2 } from '@/api/ajax';
import _ from 'lodash';
const BI_REPORT_OPTIONS = {
  1: '项目背景',
  2: '项目样本采集范围',
  3: '项目总览',
  4: '项目执行人数据统计',
  5: '项目相关调研结果',
  6: '交叉分析表与卡方分析',
  7: '单因素与多样本比较',
  8: '示例分享',
  9: '项目执行流程',
  10: '项目执行进度'
};
const BI_REPORT_OPTIONS_NEW = {
  DIRECTORY: '目录',
  BACKGROUND_INTRO: '项目背景介绍',
  SAMPLE_SCOPE: '样本采集范围',
  PROJECT_OVERVIEW: '项目总览',
  PROJECT_EXE_STAT_BEFORE: '项目执行人数据统计-数据前处理',
  PROJECT_EXE_STAT_GENDER: '项目执行人数据统计-参与任务执行的性别分析',
  PROJECT_EXE_STAT_INTERVAL: '项目执行人数据统计-项⽬参与⼈完成的任务区间分布',
  PROJECT_RESEARCH: '项目相关调研模块',
  CROSS_KAFANG_ANALYSIS: '交叉分析表与卡方分析',
  SINGLE_FACTOR_MULTI_SAMPLE: '单因素与多样本比较',
  HEAT_MAP: '相关性热图',
  EXAMPLE_SHARING: '示例分享',
  PROJECT_EXE_FLOW: '项目执行流程',
  PROJECT_EXE_PROGRESS: '项目执行进度'
};
export default {
  name: 'bi-report-options',
  props: {
    projectId: {
      type: [Number, String],
      required: true
    },
    biInfoId: {
      type: [Number, String],
      required: true
    },
    startDt: {
      type: String
    },
    endDt: {
      type: String
    }
  },
  data() {
    return {
      checkList: [],
      checkBoxList: [
        {
          label: '',
          moduleType: ''
        }
      ],
      respondData: []
    };
  },
  methods: {
    confirm() {
      let checkListData = this.respondData.map(i => {
        return {
          ...i,
          isDelete: this.checkList.includes(i.modelType) ? 0 : 1
        };
      });
      this.$emit('confirm', checkListData);
    }
  },
  async created() {
    try {
      const {
        data: { data }
      } = await BIv2.getBiModuleByBiId({
        projectId: this.projectId,
        startDt: this.startDt,
        endDt: this.endDt,
        biInfoId: this.biInfoId
      });
      if (!data.moduleList.length) {
        this.$emit('remove');
        this.$message.warning('没有可选择的模块,服务器返回数据为空');
        return;
      }
      this.respondData = _.cloneDeep(data.moduleList);
      this.checkBoxList = data.moduleList.map(i => {
        return {
          ...i,
          isProjectBiV3: data.isProjectBiV3,
          label:
            data.isProjectBiV3 != 1
              ? BI_REPORT_OPTIONS[i.modelType]
              : BI_REPORT_OPTIONS_NEW[i.modelType]
        };
      });
      //判断是否为新的,新的参与排序
      if (data.isProjectBiV3 == 1) {
        let arr = [];
        Object.keys(BI_REPORT_OPTIONS_NEW).forEach(item => {
          this.checkBoxList.forEach(citem => {
            if (citem.modelType === item) {
              arr.push(citem);
            }
          });
        });
        this.checkBoxList = arr;
      }
      this.checkList =
        data.isProjectBiV3 != 1
          ? data.moduleList.map(i => i.modelType)
          : this.checkBoxList.map(i => i.modelType);
    } catch (e) {
      console.log(e);
    }
  }
};
</script>

<style scoped></style>
